// Per-user shop favorites in localStorage (works offline, no backend call).
// Key is scoped by user email so multiple accounts on one device don't collide.

const PREFIX = "nd_fav::";

function key(userEmail) {
  return PREFIX + (userEmail || "anon");
}

export function getFavorites(userEmail) {
  try {
    const raw = localStorage.getItem(key(userEmail));
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function isFavorite(userEmail, shopId) {
  return getFavorites(userEmail).some((s) => s.id === shopId);
}

export function toggleFavorite(userEmail, shop) {
  const list = getFavorites(userEmail);
  const exists = list.some((s) => s.id === shop.id);
  const next = exists
    ? list.filter((s) => s.id !== shop.id)
    : [
        // Store a compact snapshot so the Favorites screen renders without an extra fetch
        {
          id: shop.id,
          name: shop.name,
          category: shop.category,
          address: shop.address,
          image: shop.images?.[0] || null,
          added_at: new Date().toISOString(),
        },
        ...list,
      ];
  try {
    localStorage.setItem(key(userEmail), JSON.stringify(next));
  } catch (_) {
    /* localStorage may be blocked */
  }
  window.dispatchEvent(new CustomEvent("nd_favorites_changed"));
  return !exists;
}
